import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-286">
      <Navigation data-id="element-287" />

      <main data-id="element-288">
        <Hero data-id="element-289" />
        <WhyUs data-id="element-290" />
        <Services data-id="element-291" />
        <FAQ data-id="element-292" />
        <Testimonials data-id="element-293" />
        <Consultation data-id="element-294" />
      </main>

      <Footer data-id="element-295" />
      <CookieBanner data-id="element-296" />
    </div>;
}